import Reveal from "@/components/base/Reveal";

export default function CtaBand() {
  return (
    <section className="w-full bg-background-50 pb-16 md:pb-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
            <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-primary-600/60" />
            <div className="absolute -bottom-14 -left-8 h-48 w-48 rounded-full bg-accent-500/20" />
            <div className="relative">
              <p className="font-label text-sm tracking-[0.3em] text-primary-100">剧 情 详 解</p>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                还想把结局再理顺一遍？
              </h2>
              <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
                从四个角度重新理解大结局，或回到分集脉络，对照每一步是怎么走到最后的。
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="#ending"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition hover:bg-background-100 sm:w-auto"
                >
                  <i className="ri-flag-2-line" />
                  重读大结局解析
                </a>
                <a
                  href="#episodes"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-background-50/50 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:w-auto"
                >
                  <i className="ri-list-check-2" />
                  回到分集脉络
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}